import { useTranslator } from '@Localization';
import { countries } from 'countries-list';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { Select } from '../../../../design/inputs/select/Select';
import { S_FieldLabel } from '../../../../design/labels/fieldLabel/S_FIeldLabel';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { FormAlert } from '../../../components/FormAlert';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';
import { PasswordWithScoreInputsContainer } from '../../auth/containers/PasswordWithScoreInputsContainer';

interface IRegistrationFormProps {
  emailStatus: InputStatus;
  passwordStatus: InputStatus;
  externalStatus: InputStatus;
  email: string;
  company: string;
  country: string;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onPasswordStatusChange: (status: InputStatus) => void;
  validateEmail: (value: string) => void;
  onCompanyChange: (value: string) => void;
  onCountryChange: (value: string) => void;
}

export const RegisterUserForm = observer((props: IRegistrationFormProps): ReactElement => {
  const { t } = useTranslator();

  const countryOptions = Object.entries(countries).map(([key, value]) => ({ value: key, label: value.name }));

  return (
    <S_Card>
      <ColumnLayout size='md'>
        <FormAlert
          errors={props.externalStatus}
          useDefaultMessageWhenCodeNotFound={true}
        />
        <ValidatedTextInput
          isRequired
          id='register-email-input'
          value={props.email}
          labelText={t('email_address')}
          type={'text'}
          placeholder={t('enter_business_email')}
          onChange={props.onEmailChange}
          onBlur={props.validateEmail}
          isValid={props.emailStatus.isValid}
          feedbacks={props.emailStatus.errorCodes}
        />
        <PasswordWithScoreInputsContainer
          labelText={t('password')}
          onPasswordChange={props.onPasswordChange}
          onPasswordStatusChange={props.onPasswordStatusChange}
        />
        <ValidatedTextInput
          id='register-company-input'
          value={props.company}
          labelText={t('organisation')}
          type={'text'}
          placeholder={t('enter_organisation')}
          onChange={props.onCompanyChange}
        />
        <div>
          <S_FieldLabel text={t('country')} />
          <Select
            placeholder={t('enter_country')}
            value={countryOptions.find((o) => o.value === props.country)}
            onChange={(_, v) => {
              props.onCountryChange(v.value ?? '');
            }}
            options={countryOptions}
            openOnFocus={false}
          />
        </div>
      </ColumnLayout>
    </S_Card>
  );
});
